require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-with-d-3-add-attributes-to-the-circle-elements.json") })
        }
      }, "path---data-visualization-data-visualization-with-d-3-add-attributes-to-the-circle-elements");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-with-d-3-add-attributes-to-the-circle-elements!./.cache/json/data-visualization-data-visualization-with-d-3-add-attributes-to-the-circle-elements.json
// module id = 1947
// module chunks = 231608221292675